import { Outlet } from 'react-router-dom';
import { Footer } from '../components/footer';
import { Content } from '../components/content';
import { WrapperContainer } from './styled';
import { useMe } from '../common/hooks';

export const LayoutWrapper = () => {
  useMe();

  return (
    <WrapperContainer>
      <Content>
        <Outlet />
      </Content>
      <Footer />
    </WrapperContainer>
  );
};
